import { render, staticRenderFns } from "./PostingsMultiselectNew.vue?vue&type=template&id=7ef273f6"
import script from "./PostingsMultiselectNew.vue?vue&type=script&lang=ts"
export * from "./PostingsMultiselectNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ef273f6')) {
      api.createRecord('7ef273f6', component.options)
    } else {
      api.reload('7ef273f6', component.options)
    }
    module.hot.accept("./PostingsMultiselectNew.vue?vue&type=template&id=7ef273f6", function () {
      api.rerender('7ef273f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/PostingsMultiselectNew.vue"
export default component.exports